module.exports = __webpack_public_path__ + "assets/favicons/briteCore_logo_inverse.svg";